import { render, staticRenderFns } from "./PositionComponent.vue?vue&type=template&id=2c5e8770"
import script from "./PositionComponent.vue?vue&type=script&lang=js"
export * from "./PositionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports